/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { ReactComponent as FamilySvg } from '../../../assets/icons/family.svg';
import { ReactComponent as HealthWorkersSvg } from '../../../assets/icons/health-workers.svg';
import { ReactComponent as DaysSvg } from '../../../assets/icons/days.svg';
import { ReactComponent as FeverSvg } from '../../../assets/icons/fever.svg';
import { ReactComponent as CoughingSvg } from '../../../assets/icons/coughing.svg';
import CommonTemplate from '../../../components/mobile/speak-doctor/covid/CommonTemplate';
import SliderTemplate from '../../../components/mobile/speak-doctor/covid/SliderTemplate';
import RadioBtnTemplate from '../../../components/mobile/speak-doctor/covid/RadioBtnTemplate';
import Family from '../../../components/mobile/speak-doctor/covid/Family';

const singleAnswerOptions = [
  {
    value: true,
    label: 'common:button.yes',
  },
  {
    value: false,
    label: 'common:button.no',
  },
  {
    value: `I don't know`,
    label: 'speak-doctor:covid.iDoNotKnow',
  },
];

/**
 * 0 1_answeringQuestionForYourself
 * 1 age
 * 2 family
 * 3 isWorkInHealthcareFacility
 * 4 symptoms
 * 5 additionalSymptoms
 * 6 isExposedFeverOrCoughPast14Days
 * 7 hadAFeverInTheLast14Days
 * 8 hadAContinuousCoughInTheLast14Days
 * 9 hadALossInTasteAndSmellInTheLast14Days
 * 10 beenDiagnosedWithConditions
 * 11 haveTheFollowing
 * 12 isApplyToYou
 */

const mobileCovidRoutes = [
  {
    id: '1',
    path: '/speak-doctor/covid/question-for',
    component: (props) => <CommonTemplate {...props} />,
    props: {
      fieldName: '1_answeringQuestionForYourself',
      prevRoutePath: '/speak-doctor/',
      nextRoutePath: '/speak-doctor/covid/age',
      question: 'speak-doctor:covid.question1.for-whom-answering',
      isMultiSelect: false,
      options: [
        {
          value: 'For myself',
          label: 'speak-doctor:covid.question1.forMyself',
        },
        {
          value: 'For someone else',
          label: 'speak-doctor:covid.question1.forSomeoneElse',
        },
      ],
      boxWidth: '320px',
      bodyStyle: {
        paddingTop: '20px',
        paddingBottom: '33px',
      },
    },
  },
  {
    id: '2',
    path: '/speak-doctor/covid/age',
    component: (props) => <SliderTemplate {...props} />,
    props: {
      fieldName: '2_age',
      prevRoutePath: '/speak-doctor/covid/question-for',
      nextRoutePath: '/speak-doctor/covid/gender',
      question: 'speak-doctor:covid.question2.whatIsYourAge',
      sliderTextValue: 'speak-doctor:covid.question2.yearOld',
      sliderMinValue: 14,
      sliderMaxValue: 70,
      svgIcon: () => <FamilySvg />,
      bodyStyle: {
        paddingTop: '53px',
        paddingBottom: '90px',
      },
      titleStyle: {
        paddingTop: '24px',
      },
    },
  },
  {
    id: '3',
    path: '/speak-doctor/covid/gender',
    component: (props) => <RadioBtnTemplate {...props} />,
    props: {
      fieldName: '3_gender',
      prevRoutePath: '/speak-doctor/covid/age',
      nextRoutePath: '/speak-doctor/covid/family',
      question: 'speak-doctor:covid.question3.whatIsYourGender',
      options: [
        {
          value: 'female',
          label: 'speak-doctor:covid.question3.female',
        },
        {
          value: 'male',
          label: 'speak-doctor:covid.question3.male',
        },
      ],
      bodyStyle: {
        paddingTop: '64px',
        paddingBottom: '101px',
      },
      titleStyle: {
        paddingTop: '24px',
      },
    },
  },
  {
    id: '4',
    path: '/speak-doctor/covid/family',
    component: (props) => <Family {...props} />,
    props: {
      fieldName: '4_howManyPeopleDoYouLiveWith',
      prevRoutePath: '/speak-doctor/covid/gender',
      nextRoutePath: '/speak-doctor/covid/work-in-a-healthcare-facility',
      question: 'speak-doctor:covid.question4.howManyPeopleDoYouLiveWith',
    },
  },
  {
    id: '5',
    path: '/speak-doctor/covid/work-in-a-healthcare-facility',
    component: (props) => <RadioBtnTemplate {...props} />,
    props: {
      fieldName: '5_doYouOrAnyoneYouLiveWorkHealthcareFacility',
      prevRoutePath: '/speak-doctor/covid/family',
      nextRoutePath: '/speak-doctor/covid/symptoms',
      question: 'speak-doctor:covid.question5.workInHealthcareFacility',
      options: singleAnswerOptions.slice(0, 2),
      svgIcon: () => <HealthWorkersSvg />,
      bodyStyle: {
        paddingTop: '64px',
        paddingBottom: '101px',
      },
      titleStyle: {
        paddingTop: '24px',
      },
    },
  },
  {
    id: '6',
    path: '/speak-doctor/covid/symptoms',
    component: (props) => <CommonTemplate {...props} />,
    props: {
      fieldName: '6_doYouHaveAnySymptoms',
      prevRoutePath: '/speak-doctor/covid/work-in-a-healthcare-facility',
      nextRoutePath: '/speak-doctor/covid/additional-symptoms',
      question: 'speak-doctor:covid.question6.haveSymptoms',
      hint: 'speak-doctor:covid.hint',
      isMultiSelect: true,
      options: [
        {
          value: 'Cough',
          label: 'speak-doctor:covid.question6.symptoms.cough',
        },
        {
          value: 'Feeling hot or feverish',
          label: 'speak-doctor:covid.question6.symptoms.feelingHotOrFeverish',
        },
        {
          value: 'Difficulty breathing',
          label: 'speak-doctor:covid.question6.symptoms.difficultyBreathing',
        },
        {
          value: 'none',
          label: 'speak-doctor:covid.noneOfThese',
        },
      ],
      bodyStyle: {
        paddingTop: '34px',
        paddingBottom: '48px',
      },
    },
  },
  {
    id: '7',
    path: '/speak-doctor/covid/additional-symptoms',
    component: (props) => <CommonTemplate {...props} />,
    props: {
      fieldName: '7_doYouHaveAnySymptoms',
      prevRoutePath: '/speak-doctor/covid/symptoms',
      nextRoutePath: '/speak-doctor/covid/exposed-a-fever-or-a-cough-in-the-past-14-days',
      question: 'speak-doctor:covid.question7.haveSymptoms',
      hint: 'speak-doctor:covid.hint',
      isMultiSelect: true,
      options: [
        {
          value: 'Aches and pains in muscles',
          label: 'speak-doctor:covid.question7.symptoms.achesAndPainsInMuscles',
        },
        {
          value: 'Sore throat',
          label: 'speak-doctor:covid.question7.symptoms.soreThroat',
        },
        {
          value: 'Diarrhoea',
          label: 'speak-doctor:covid.question7.symptoms.diarrhoea',
        },
        {
          value: 'Nausea',
          label: 'speak-doctor:covid.question7.symptoms.nausea',
        },
        {
          value: 'Runny nose',
          label: 'speak-doctor:covid.question7.symptoms.runnyNose',
        },
        {
          value: 'I have lost my sense of taste and smell',
          label: 'speak-doctor:covid.question7.symptoms.iHaveLostMySenseOfTasteAndSmell',
        },
        {
          value: 'none',
          label: 'speak-doctor:covid.noneOfThese',
        },
      ],
      bodyStyle: {
        paddingTop: '34px',
        paddingBottom: '46px',
      },
    },
  },
  {
    id: '8',
    path: '/speak-doctor/covid/exposed-a-fever-or-a-cough-in-the-past-14-days',
    component: (props) => <CommonTemplate {...props} />,
    props: {
      fieldName: '8_exposedToSomeoneWithFever',
      prevRoutePath: '/speak-doctor/covid/additional-symptoms',
      nextRoutePath: '/speak-doctor/covid/had-a-fever-in-the-last-14-days',
      question: 'speak-doctor:covid.question8.exposedAFeverOrACoughInThePast14Days',
      isMultiSelect: false,
      options: [...singleAnswerOptions],
      bodyStyle: {
        paddingTop: '64px',
        paddingBottom: '78px',
      },
    },
  },
  {
    id: '9',
    path: '/speak-doctor/covid/had-a-fever-in-the-last-14-days',
    component: (props) => <CommonTemplate {...props} />,
    props: {
      fieldName: '9a_hadFeverStatus',
      prevRoutePath: '/speak-doctor/covid/exposed-a-fever-or-a-cough-in-the-past-14-days',
      nextRoutePath: '/speak-doctor/covid/had-a-loss-in-taste-and-smell-in-the-last-14-days',
      additionalRoute: '/speak-doctor/covid/days-had-a-fever',
      question: 'speak-doctor:covid.question9.hadAFeverInTheLast14Days',
      hint: 'speak-doctor:covid.question9.hint',
      isMultiSelect: false,
      options: [...singleAnswerOptions],
      svgIcon: () => <FeverSvg />,
      bodyStyle: {
        paddingTop: '35px',
        paddingBottom: '36px',
      },
      titleStyle: {
        paddingTop: '16px',
      },
    },
  },
  {
    id: '10',
    path: '/speak-doctor/covid/had-a-loss-in-taste-and-smell-in-the-last-14-days',
    component: (props) => <CommonTemplate {...props} />,
    props: {
      fieldName: '9b_tasteSmellStatus',
      prevRoutePath: '/speak-doctor/covid/had-a-fever-in-the-last-14-days',
      nextRoutePath: '/speak-doctor/covid/experienced-a-new-and-continuous-cough-in-the-last-14-days',
      additionalRoute: '/speak-doctor/covid/days-had-a-loss-in-taste-and-smell',
      recommendedRoute: '/patient-data/green-category',
      question: 'speak-doctor:covid.question11.beenDiagnosedWithConditions',
      isMultiSelect: false,
      options: [...singleAnswerOptions],
      svgIcon: () => <FeverSvg />,
      bodyStyle: {
        paddingTop: '35px',
        paddingBottom: '36px',
      },
      titleStyle: {
        paddingTop: '16px',
      },
    },
  },
  {
    id: '11',
    path: '/speak-doctor/covid/experienced-a-new-and-continuous-cough-in-the-last-14-days',
    component: (props) => <CommonTemplate {...props} />,
    props: {
      fieldName: '10_continuousCoughStatus',
      prevRoutePath: '/speak-doctor/covid/had-a-loss-in-taste-and-smell-in-the-last-14-days',
      nextRoutePath: '/speak-doctor/covid/been-diagnosed-with-conditions',
      additionalRoute: '/speak-doctor/covid/days-had-a-new-and-continuous-cough',
      question: 'speak-doctor:covid.question10.hadAContinuousCoughInTheLast14Days',
      hint: 'speak-doctor:covid.question10.hint',
      isMultiSelect: false,
      options: [...singleAnswerOptions],
      svgIcon: () => <CoughingSvg />,
      bodyStyle: {
        paddingTop: '35px',
        paddingBottom: '36px',
      },
      titleStyle: {
        paddingTop: '16px',
      },
    },
  },
  {
    id: '12',
    path: '/speak-doctor/covid/been-diagnosed-with-conditions',
    component: (props) => <CommonTemplate {...props} />,
    props: {
      fieldName: '11_diagnosedWith',
      prevRoutePath: '/speak-doctor/covid/experienced-a-new-and-continuous-cough-in-the-last-14-days',
      nextRoutePath: '/speak-doctor/covid/have-the-following',
      question: 'speak-doctor:covid.question12.beenDiagnosedWithConditions',
      hint: 'speak-doctor:covid.hint',
      isMultiSelect: true,
      options: [
        {
          value: 'High blood pressure',
          label: 'speak-doctor:covid.question12.conditions.highBloodPressure',
        },
        {
          value: 'Heart disease',
          label: 'speak-doctor:covid.question12.conditions.heartDisease',
        },
        {
          value: 'Obesity (BMI over 40)',
          label: 'speak-doctor:covid.question12.conditions.obesityBbiOver40',
        },
        {
          value: 'Diabetes',
          label: 'speak-doctor:covid.question12.conditions.diabetes',
        },
        {
          value: 'none',
          label: 'speak-doctor:covid.noneOfThese',
        },
      ],
      bodyStyle: {
        paddingTop: '35px',
        paddingBottom: '48px',
      },
    },
  },
  {
    id: '13',
    path: '/speak-doctor/covid/have-the-following',
    component: (props) => <CommonTemplate {...props} />,
    props: {
      fieldName: '12_any',
      prevRoutePath: '/speak-doctor/covid/been-diagnosed-with-conditions',
      nextRoutePath: '/speak-doctor/covid/apply',
      question: 'speak-doctor:covid.question13.haveTheFollowing',
      hint: 'speak-doctor:covid.hint',
      isMultiSelect: true,
      options: [
        {
          value: 'Kidney, lung, or liver disease',
          label: 'speak-doctor:covid.question13.conditions.kidneyLungOrLiverDisease',
        },
        {
          value: 'Spleen problems such as sickle cell disease or spleen removal',
          label: 'speak-doctor:covid.question13.conditions.spleenProblems',
        },
        {
          value: "Neurological disorder such as Parkinson's or multiple sclerosis",
          label: 'speak-doctor:covid.question13.conditions.neurologicalDisorder',
        },
        {
          value:
            'Weak or lowered immune system due to HIV or taking long-term oral steroid tablets',
          label: 'speak-doctor:covid.question13.conditions.weak',
        },
        {
          value: 'none',
          label: 'speak-doctor:covid.noneOfThese',
        },
      ],
      boxWidth: '320px',
      bodyStyle: {
        paddingTop: '56px',
        paddingBottom: '36px',
      },
      titleStyle: {
        paddingBottom: '55px',
      },
    },
  },
  {
    id: '14',
    path: '/speak-doctor/covid/apply',
    component: (props) => <CommonTemplate {...props} />,
    props: {
      fieldName: '13_applyToYou',
      prevRoutePath: '/speak-doctor/covid/have-the-following',
      nextRoutePath: '',
      question: 'speak-doctor:covid.question14.isApplyToYou',
      hint: 'speak-doctor:covid.hint',
      isLastQuestion: true,
      isMultiSelect: true,
      options: [
        {
          value: 'Pregnant',
          label: 'speak-doctor:covid.question14.conditions.pregnant',
        },
        {
          value: 'Have had an organ transplant',
          label: 'speak-doctor:covid.question14.conditions.haveHadAnOrganTransplant',
        },
        {
          value: 'Had a bone marrow transplant in the past 6 months',
          label:
            'speak-doctor:covid.question14.conditions.hadBoneMarrowTransplantInThePast6Months',
        },
        {
          value: 'Currently having chemotherapy or radiotherapy',
          label:
            'speak-doctor:covid.question14.conditions.currentlyHavingChemotherapyOrRadiotherapy',
        },
        {
          value: 'Being treated for leukaemia, lymphoma or myeloma',
          label:
            'speak-doctor:covid.question14.conditions.beingTreatedForLeukaemiaLymphomaOrMyeloma',
        },
        {
          value:
            'Currently diagnosed with cystic fibrosis, severe asthma or server COPD (Chronic obstructive pulmonary disease)',
          label: 'speak-doctor:covid.question14.conditions.currentlyDiagnosedWithCysticFibrosis',
        },
        {
          value: 'Kidney disease and on dialysis',
          label: 'speak-doctor:covid.question14.conditions.kidneyDiseaseAndOnDialysis',
        },

        {
          value: 'none',
          label: 'speak-doctor:covid.noneOfThese',
        },
      ],
      boxWidth: '320px',
      bodyStyle: {
        paddingTop: '56px',
        paddingBottom: '36px',
      },
      titleStyle: {
        paddingBottom: '55px',
      },
    },
  },
];

const mobileFromYesAnswerRoutes = [
  {
    id: '7',
    path: '/speak-doctor/covid/days-had-a-fever',
    component: (props) => <SliderTemplate {...props} />,
    props: {
      fieldName: '9a_hadFeverDays',
      prevRoutePath: '/speak-doctor/covid/had-a-fever-in-the-last-14-days',
      nextRoutePath: '/speak-doctor/covid/had-a-loss-in-taste-and-smell-in-the-last-14-days',
      question: 'speak-doctor:covid.questionsFromYesAnswer.howManyDaysHaveYouHadAFever',
      sliderTextValue: 'speak-doctor:covid.questionsFromYesAnswer.days',
      sliderMinValue: 0,
      sliderMaxValue: 14,
      svgIcon: () => <DaysSvg />,
      bodyStyle: {
        paddingTop: '43px',
        paddingBottom: '80px',
      },
      titleStyle: {
        paddingTop: '16px',
      },
    },
  },
  {
    id: '8',
    path: '/speak-doctor/covid/days-had-a-loss-in-taste-and-smell',
    component: (props) => <SliderTemplate {...props} />,
    props: {
      fieldName: '9b_tasteSmellDays',
      prevRoutePath: '/speak-doctor/covid/had-a-loss-in-taste-and-smell-in-the-last-14-days',
      nextRoutePath: '/speak-doctor/covid/experienced-a-new-and-continuous-cough-in-the-last-14-days',
      question:
        'speak-doctor:covid.questionsFromYesAnswer.howManyDaysHaveYouHadALossOfTasteAndSmell',
      sliderTextValue: 'speak-doctor:covid.questionsFromYesAnswer.days',
      sliderMinValue: 0,
      sliderMaxValue: 14,
      svgIcon: () => <DaysSvg />,
      bodyStyle: {
        paddingTop: '43px',
        paddingBottom: '80px',
      },
      titleStyle: {
        paddingTop: '16px',
      },
    },
  },
  {
    id: '8',
    path: '/speak-doctor/covid/days-had-a-new-and-continuous-cough',
    component: (props) => <SliderTemplate {...props} />,
    props: {
      fieldName: '10_continuousCoughDays',
      prevRoutePath:
        '/speak-doctor/covid/experienced-a-new-and-continuous-cough-in-the-last-14-days',
      nextRoutePath: '/speak-doctor/covid/been-diagnosed-with-conditions',
      question:
        'speak-doctor:covid.questionsFromYesAnswer.howManyDaysHaveYouHadAnewAndContinuousCough',
      sliderTextValue: 'speak-doctor:covid.questionsFromYesAnswer.days',
      sliderMinValue: 0,
      sliderMaxValue: 14,
      svgIcon: () => <DaysSvg />,
      bodyStyle: {
        paddingTop: '43px',
        paddingBottom: '80px',
      },
      titleStyle: {
        paddingTop: '16px',
      },
    },
  },
];

export const getMobileCovidRoutes = () => mobileCovidRoutes;

export const getMobileCovidFromYesAnswerRoutes = () => mobileFromYesAnswerRoutes;
